import { ActionEvent } from '../tool/action/action-event';
import { SimpleAction } from '../tool/action/simple-action';

export class ActionEventBuilder {
  public type: 'click' | 'input' | 'select' | 'close';
  public action: SimpleAction<any>;
  public value: any = null;
  public event: MouseEvent = null;

  constructor(
    type: 'click' | 'input' | 'select' | 'close',
    action: SimpleAction<any>,
  ) {
    this.setType(type);
    this.setAction(action);
    this.value = null;
    this.event = null;
  }

  public setType(
    type: 'click' | 'input' | 'select' | 'close',
  ): ActionEventBuilder {
    this.type = type;
    return this;
  }

  public setAction(action: SimpleAction<any>): ActionEventBuilder {
    this.action = action;
    return this;
  }

  public setValue(value: any): ActionEventBuilder {
    this.value = value;
    return this;
  }

  public setEvent(event: MouseEvent): ActionEventBuilder {
    this.event = event;
    return this;
  }

  public build(): ActionEvent {
    const actionEvent = new ActionEvent(this.type, this.action);
    actionEvent.value = this.value;
    actionEvent.event = this.event;
    return actionEvent;
  }
}
